import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f0dcf6d2&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=f0dcf6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dcf6d2",
  null
  
)

export default component.exports